/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Goals {
	"use strict";

    import GoalInputTypeEnum = Meevo.Components.Goals.GoalInputTypeEnum;
	import IGoalColumn = Meevo.Components.Goals.IGoalColumn;


	export class MeevoGoalInputTypeComponent implements ng.IComponentController {
		public goalInputTypeEnum = GoalInputTypeEnum;
		change: Function;
		model: IGoalColumn;
		currentValue: number;

		$onInit() {

		}

        changeModel() {
            if (isNaN(this.model.value)) this.model.value = 0;

			this.change(this.model);
		}
	}

    angular.module('meevo.components.controls')
		.component('meevoGoalInputTypeComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/goals/inputType/inputType.component.html',
			controller: MeevoGoalInputTypeComponent,
			controllerAs: '$ctrl',
			bindings: {
				model: "=ngModel",
				disabled: "=ngDisabled",
				required: "=ngRequired",
				change: "&ngChange",
				currentValue: '=',
                decimalMask: "=?",
                changeValuesOnInit: "=?"
			}
		});
}